import { TefComs4p } from '@mfe/components/TefComs4p';
import { Subscription } from '@mfec/types/model';
import { formatMsisdn } from '@mfec/utils/MobilePhoneNumber';
import { html } from 'lit';

//
// renders a single subscription block in EDIT mode
//
// {subscription msisdn}
//   {app consent BLOCK}
//
export const singleSubscriptionIdentifierBoundEdit = function render(this: TefComs4p, subscription : Subscription) {
  return html`
    <one-section size="xxs" background="muted-2">
      <one-heading level="h6" variant="default">${formatMsisdn(subscription.msisdn)}</one-heading>
    </one-section>

    <one-stack gap="xs">
      ${subscription.apps.map((app) => this.getTemplateFn('singleAppConsentEdit')(app))}
      <one-checkbox ?checked="${!subscription.apps.some((app) => app.granted)}" @change=${() => { this.revokeAllAppConsentsForSubscription(subscription); }}>
        <one-text size="lg">Alle deaktivieren</one-text>
      </one-checkbox>
    </one-stack>
  `;
};
